import * as Select from '@radix-ui/react-select';
import { PAISES, acharPais } from './paises';
import s from './SeletorRede.module.css';

/**
 * Pais do telefone, com bandeira e DDI.
 *
 * Reaproveita o CSS do SeletorRede: sao o mesmo componente visual com
 * conteudo diferente. Duplicar o estilo faria os dois divergirem no
 * primeiro ajuste.
 *
 * O gatilho mostra so bandeira + DDI para caber ao lado do numero; a
 * lista aberta traz o nome do pais.
 */
export function SeletorPais({ valor, aoMudar, id }: {
  valor: string;
  aoMudar: (iso: string) => void;
  id?: string;
}) {
  const atual = acharPais(valor);

  return (
    <Select.Root value={valor} onValueChange={aoMudar}>
      <Select.Trigger className={s.gatilho} id={id} aria-label="País do telefone">
        <span className={s.icone} aria-hidden>{atual.bandeira}</span>
        <Select.Value asChild>
          <span className={s.valor}>+{atual.ddi}</span>
        </Select.Value>
        <span className={s.seta}>{'▼'}</span>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content className={s.conteudo} position="popper" sideOffset={5}>
          <Select.Viewport className={s.viewport}>
            {PAISES.map((p) => (
              <Select.Item key={p.iso} value={p.iso} className={s.item}>
                <span className={s.icone} aria-hidden>{p.bandeira}</span>
                <Select.ItemText>{p.nome}</Select.ItemText>
                <span style={{ marginLeft: 'auto', color: 'var(--muted)', fontSize: 13 }}>
                  +{p.ddi}
                </span>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}
